import { TouchEventHandler, useContext, useRef, useState } from "react";
import { SWIPE_DRAWER_SCROLL_AREA_WIDTH } from "common/constants.ts";
import { SwipeFiltersContext } from "common/Filters/common/SwipeFilters.context.ts";
import useDrawers from "common/Home/useDrawers.tsx";

interface UseSwipeDrawerProps {
  isDisabled?: boolean;
}

const useSwipeDrawer = ({ isDisabled }: UseSwipeDrawerProps) => {
  const [open, setOpen] = useState(false);
  const startXRef = useRef<number | null>(null);
  const startYRef = useRef<number | null>(null);
  const { swipeActiveRef } = useContext(SwipeFiltersContext) || {};
  const { isDrawer } = useDrawers();

  const showDrawer = () => {
    setOpen(true);
  };
  const closeDrawer = () => {
    setOpen(false);
  };

  const onTouchStart: TouchEventHandler<HTMLDivElement> = (e) => {
    const touch = e.touches[0];
    startXRef.current = touch.clientX;
    startYRef.current = e.touches[0].clientY;

    if (
      swipeActiveRef &&
      touch.clientX > window.innerWidth - SWIPE_DRAWER_SCROLL_AREA_WIDTH
    ) {
      e.stopPropagation();
      swipeActiveRef.current = true;
    }
  };

  const onTouchMove: TouchEventHandler<HTMLDivElement> = (e) => {
    const touch = e.touches[0];
    const deltaX = touch.clientX - (startXRef.current || 0);
    const deltaY = Math.abs(touch.clientY - (startYRef.current || 0));

    if (
      !open &&
      (startXRef.current || 0) >
        window.innerWidth - SWIPE_DRAWER_SCROLL_AREA_WIDTH &&
      deltaX < -20 &&
      deltaY < 10
    ) {
      showDrawer();
    }
  };

  const onTouchEnd: TouchEventHandler<HTMLDivElement> = () => {
    if (swipeActiveRef) {
      swipeActiveRef.current = false;
    }
  };

  const swipeDrawerProps =
    isDisabled || isDrawer
      ? undefined
      : {
          onTouchStart,
          onTouchMove,
          onTouchEnd,
        };

  return {
    open,
    closeDrawer,
    swipeDrawerProps,
  };
};

export default useSwipeDrawer;
